import { Input } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { DatePicker } from '../DatePicker';
import { ArrowRightOutlined } from '@ant-design/icons';

export default function ParkingAtDateMonthly({
  setChangedDateTime,
  dateRange,
  hchangeCheckin,
  changedDateTime,
  deviceType,
  facility,
}) {
  const [ui, setUi] = useState({
    checkin: null,
    checkout: null,
    modCheckin: null,
    modCheckout: null,
    sleepAt: null,
  });

  useEffect(() => {
    const vcheckin = dayjs(dateRange.checkIn);

    const vcheckout =
      facility.facilityParkingType === 4
        ? vcheckin.clone().add(1, 'month')
        : dayjs(dateRange.checkOut);

    setUi({
      checkin: vcheckin,
      checkout: vcheckout,
      modCheckin: vcheckin,
      modCheckout: vcheckout,
      sleepAt: dateRange.sleepAt,
    });
  }, [
    dateRange.checkIn,
    dateRange.checkOut,
    dateRange.sleepAt,
    facility.facilityParkingType,
  ]);
  const today = dayjs();
  const changeCheckout = (date, hourmin) => {
    let newDate = ui.modCheckout ?? ui.checkout;
    if (date) {
      newDate = dayjs(date);
    }
    if (hourmin) {
      const [hour, min, period] = hourmin.split(/:|\W+/g);
      newDate = newDate.hour(Number(hour)).minute(Number(min)).second(0);
    }
    let checkin = null;
    if (newDate.isSame(ui.modCheckin) || ui.modCheckin.isAfter(newDate)) {
      checkin = newDate.subtract(1, 'day');
      if (checkin.isBefore(today) || hourmin) {
        if (hourmin) {
          console.log(hourmin, 'hourm');
          const [hour, min] = hourmin.split(/:|\W+/g);
          checkin = today.hour(Number(hour)).minute(Number(min)).second(0);
          newDate = checkin.add(1, 'day');
        } else {
          return;
        }
      }
    }

    setChangedDateTime({
      ...changedDateTime,
      checkOut: true,
      dtCheckout: newDate,
      checkIn: checkin ? true : changedDateTime.checkIn,
      dtCheckin: checkin ? checkin : changedDateTime.dtCheckin,
    });
    setUi({
      ...ui,
      modCheckout: newDate,
      modCheckin: checkin ? checkin : ui.modCheckin,
    });
  };
  const changeCheckin = (date, hourmin) => {
    let newDate = ui.modCheckin ?? ui.checkin;
    if (date) {
      newDate = dayjs(date);
    }
    if (hourmin) {
      const [hour, min, _period] = hourmin?.split(/:|\W+/g);
      newDate = newDate.hour(Number(hour)).minute(Number(min)).second(0);
    }

    let checkout = null;
    if (newDate.isSame(ui.modCheckout) || ui.modCheckout.isBefore(newDate)) {
      checkout = newDate.add(1, 'day');
    }

    if (facility.facilityParkingType == 4) {
      checkout = newDate.add(1, 'month');
    }

    setChangedDateTime({
      ...changedDateTime,
      checkIn: true,
      dtCheckin: newDate,
      checkOut: checkout ? true : changedDateTime.checkOut,
      dtCheckout: checkout ? checkout : changedDateTime.dtCheckout,
    });
    setUi({
      ...ui,
      modCheckin: newDate,
      modCheckout: checkout ? checkout : ui.modCheckout,
    });
  };
  if (!ui.checkin || !ui.checkout) return <></>;
  return (
    <div
      className={
        'flex flex-row justify-between items-center py-2 px-4 md:px-0 md:mx-none md:mt-0 gap-x-4 md:gap-x-2 search-easepick w-full'
      }
    >
      <div className="flex flex-col">
        <label className="font-bold" htmlFor="checkIn">
          {deviceType == 'mobile' ? 'Parking Check-In' : 'Start Date'}
        </label>

        {deviceType !== 'mobile' ? (
          <div className="h-10 border rounded-md px-3 w-full cursor-pointer">
            <DatePicker
              id="checkIn"
              data-test-id="mob_start_date"
              allowClear
              defaultValue={ui.modCheckin}
              format="MM/DD/YYYY"
              onChange={(value) => {
                changeCheckin(value, null);
                hchangeCheckin(value);
              }}
              bordered={false}
              className="w-full h-10"
              size="middle"
              disabledDate={(currentDate) =>
                currentDate && currentDate < dayjs().startOf('day')
              }
            />
          </div>
        ) : (
          <Input
            id="checkIn"
            data-test-id="mob_start_date"
            type="date"
            required
            inputMode="none"
            value={ui.modCheckin?.format('YYYY-MM-DD')}
            pattern="\d{4}-\d{2}-\d{2}"
            placeholder="Starting parking at"
            onChange={(evt) => {
              changeCheckin(evt.target.value, ui.modCheckin?.format('HH:mm'));
              hchangeCheckin(evt.target.value);
            }}
            bordered={false}
            className="h-10 md:border rounded-md md:px-3 w-full cursor-pointer"
          />
        )}
      </div>
      {deviceType == 'mobile' && <ArrowRightOutlined />}
      <div className="flex flex-col">
        <label className="font-bold" htmlFor="checkOut">
          {deviceType == 'mobile' ? 'Parking Check-Out' : 'End Date'}
        </label>

        {deviceType !== 'mobile' ? (
          <div className="h-10 border rounded-md px-3 w-full cursor-pointer">
            <DatePicker
              id="checkOut"
              data-test-id="mob_end_date"
              allowClear
              value={ui.modCheckout}
              format="MM/DD/YYYY"
              onChange={(value) => {
                changeCheckout(value, null);
              }}
              bordered={false}
              className="w-full h-10"
              size="middle"
              disabled={facility.facilityParkingType == 4}
              disabledDate={(currentDate) =>
                currentDate < ui.modCheckin.startOf('day')
              }
            />
          </div>
        ) : (
          <Input
            id="checkOut"
            data-test-id="mob_end_date"
            type="date"
            required
            inputMode="none"
            value={ui.modCheckout?.format('YYYY-MM-DD')}
            pattern="\d{4}-\d{2}-\d{2}"
            placeholder="End parking at"
            disabled={facility.facilityParkingType == 4}
            onChange={(evt) => {
              changeCheckout(evt.target.value, ui.modCheckout?.format('HH:mm'));
            }}
            bordered={false}
            className="h-10 md:border rounded-md md:px-3 w-full cursor-pointer"
          />
        )}
      </div>
    </div>
  );
}
